<template lang="pug">
  #login
</template>

<script>
const _ = require('lodash');

export default {
    name: 'Login',
    mounted() {
        const vm = this;
        vm.$swal.fire({
          title: '載入中，請稍候',
          allowOutsideClick: false,
          willOpen: () => {
            this.$swal.showLoading();
            // 這邊檢查回傳的參數
            const params = vm.$route.query;
            // 錯誤直接跳 swal 要求重開
            if (params.error !== undefined && params.error !== null) {
              vm.$store.commit('toggleLoading', false);
              vm.$swal.fire({
                icon: 'error',
                allowOutsideClick: false,
                allowEscapeKey: false,
                allowEnterKey: false,
                showConfirmButton: false,
                title: params.error,
                text: '請關閉後重新再試一次'
              });
              return;
            }

            const query = {};
            _.forIn(params, (value, key) => {
              if (key !== 'token' && key !== 'final_route_name') {
                query[key] = value;
              }
            });

            // 存入 token
            window.sessionStorage.setItem('token', decodeURIComponent(params.token.replace(/ /g, '+'))); // token 必須把空白換回加號
            this.$swal.close();
            vm.$router.push({ name: params.final_route_name, params: query });
          }
        });
    }
};
</script>

<style>

</style>
